export const API_URL_FETCH_WEBDEALS = "/shop/api/webdeals";
